/*!

=========================================================
* Argon Dashboard PRO React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
// redux
import { useSelector, useDispatch } from "react-redux";
// react library for routing
import {
  useLocation,
  useHistory,
  NavLink as NavLinkRRD,
} from "react-router-dom";
// Firebase
import firebase from "firebase";
// nodejs library that concatenates classes
import classnames from "classnames";
// nodejs library to set properties for components
import { PropTypes } from "prop-types";
// react library that creates nice scrollbar on windows devices
import PerfectScrollbar from "react-perfect-scrollbar";
// reactstrap components
import {
  Collapse,
  Badge,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Card,
  CardHeader,
  Button,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Row,
  Col,
  Modal,
} from "reactstrap";
// react plugin for creating notifications over the dashboard
import NotificationAlert from "react-notification-alert";
// react component used to create sweet alerts
import ReactBSAlert from "react-bootstrap-sweetalert";

// User component
import User from "views/pages/main/User";
import Loading from "components/Misc/Loading";

// Filter actions
import { setFilter } from "actions/filterActions";
// checklist actions
import {
  createDataStructure,
  getPerformanceData,
  setFranchises,
  createFranchise,
  deleteLocation,
} from "actions/checklistActions";

const states = [
  "Alabama",
  "Alaska",
  "American Samoa",
  "Arizona",
  "Arkansas",
  "California",
  "Colorado",
  "Connecticut",
  "Delaware",
  "District Of Columbia",
  "Federated States Of Micronesia",
  "Florida",
  "Georgia",
  "Guam",
  "Hawaii",
  "Idaho",
  "Illinois",
  "Indiana",
  "Iowa",
  "Kansas",
  "Kentucky",
  "Louisiana",
  "Maine",
  "Marshall Islands",
  "Maryland",
  "Massachusetts",
  "Michigan",
  "Minnesota",
  "Mississippi",
  "Missouri",
  "Montana",
  "Nebraska",
  "Nevada",
  "New Hampshire",
  "New Jersey",
  "New Mexico",
  "New York",
  "North Carolina",
  "North Dakota",
  "Northern Mariana Islands",
  "Ohio",
  "Oklahoma",
  "Oregon",
  "Palau",
  "Pennsylvania",
  "Puerto Rico",
  "Rhode Island",
  "South Carolina",
  "South Dakota",
  "Tennessee",
  "Texas",
  "Utah",
  "Vermont",
  "Virgin Islands",
  "Virginia",
  "Washington",
  "West Virginia",
  "Wisconsin",
  "Wyoming",
];

function Sidebar({ toggleSidenav, sidenavOpen, routes, logo, rtlActive }) {
  const [state, setState] = React.useState({});
  const [locations, setLocations] = React.useState([]);
  const [users, setUsers] = React.useState([]);
  const [userModal, setUserModal] = React.useState(false);
  const [modalFranchise, setModalFranchise] = React.useState(false);
  const [alert, setAlert] = React.useState(false);
  const userState = useSelector(state => state.user);
  const checklistsState = useSelector(state => state.checklists);
  const [loadingActive, setLoadingActive] = React.useState(false);
  const filterState = useSelector(state => state.filter);
  const location = useLocation();
  const history = useHistory();
  const [checklistItems, setChecklistItems] = React.useState([]);
  const dispatch = useDispatch();
  const isMounted = React.useRef(false);
  const notificationAlertRef = React.useRef(null);
  const [modalTitle, setModalTitle] = React.useState(null);
  const [checklistToUpdate, setChecklistToUpdate] = React.useState(null);
  const [checklistToCopy, setChecklistToCopy] = React.useState(null);

  // Modal
  const [accountType, setAccountType] = React.useState(
    userState.user.role === "owner" ? "manager" : null
  );
  const [alternativeFranchise, setAlternativeFranchise] = React.useState(false);

  // Focus state
  const [focusedFranchiseSelect, setFocusedFranchiseSelect] =
    React.useState(false);
  const [focusedLocationSelect, setFocusedLocationSelect] =
    React.useState(false);
  const [focusedEmail, setFocusedEmail] = React.useState(false);
  const [focusedCode, setFocusedCode] = React.useState(false);
  const [focusedState, setFocusedState] = React.useState(false);
  const [focusedName, setFocusedName] = React.useState(false);
  const [focusedFranchise, setFocusedFranchise] = React.useState(false);
  const [focusedStreetName, setFocusedStreetName] = React.useState(false);
  const [focusedStreetNumber, setFocusedStreetNumber] = React.useState(false);

  // Content State
  const [checklistName, setChecklistName] = React.useState(null);
  const [franchiseSelect, setFranchiseSelect] = React.useState([]);
  const [locationSelect, setLocationSelect] = React.useState([]);
  const [startTime, setStartTime] = React.useState(null);
  const [endTime, setEndTime] = React.useState(null);
  const [enviroMasterChecklist, setEnviroMasterChecklist] = React.useState(
    userState.user.role === "owner" ? false : null
  );
  const [QRNeeded, setQRNeeded] = React.useState(false);
  const [streetNameState, setStreetNameState] = React.useState("");
  const [streetNumberState, setStreetNumberState] = React.useState("");
  const [stateState, setStateState] = React.useState("");
  const [email, setEmail] = React.useState(false);
  const [code, setCode] = React.useState(null);
  const [name, setName] = React.useState(null);
  // Weekday checkboxes
  const [mondayCheckbox, setMondayCheckbox] = React.useState(null);
  const [tuesdayCheckbox, setTuesdayCheckbox] = React.useState(null);
  const [wednesdayCheckbox, setWednesdayCheckbox] = React.useState(null);
  const [thursdayCheckbox, setThursdayCheckbox] = React.useState(null);
  const [fridayCheckbox, setFridayCheckbox] = React.useState(null);
  const [saturdayCheckbox, setSaturdayCheckbox] = React.useState(null);
  const [sundayCheckbox, setSundayCheckbox] = React.useState(null);

  // Valid State
  const [validFranchiseSelect, setValidFranchiseSelect] = React.useState(false);
  const [validLocationSelect, setValidLocationSelect] = React.useState(false);
  const [validEmail, setValidEmail] = React.useState(false);
  const [validCode, setValidCode] = React.useState(false);
  const [validStateState, setValidStateState] = React.useState(false);
  const [validName, setValidName] = React.useState(false);
  const [validStreetName, setValidStreetName] = React.useState(null);
  const [validStreetNumber, setValidStreetNumber] = React.useState(null);

  const [validChecklistName, setValidChecklistName] = React.useState(null);
  const [validStartTime, setValidStartTime] = React.useState(null);
  const [validEndTime, setValidEndTime] = React.useState(null);
  const [validEnviroMasterChecklist, setValidEnviroMasterChecklist] =
    React.useState(userState.user.role === "owner" ? "valid" : null);
  // Weekday checkboxes
  const [validMondayCheckbox, setValidMondayCheckbox] = React.useState(null);
  const [validTuesdayCheckbox, setValidTuesdayCheckbox] = React.useState(null);
  const [validWednesdayCheckbox, setValidWednesdayCheckbox] =
    React.useState(null);
  const [validThursdayCheckbox, setValidThursdayCheckbox] =
    React.useState(null);
  const [validFridayCheckbox, setValidFridayCheckbox] = React.useState(null);
  const [validSaturdayCheckbox, setValidSaturdayCheckbox] =
    React.useState(null);
  const [validSundayCheckbox, setValidSundayCheckbox] = React.useState(null);

  const qrCodeRef = React.useRef();

  React.useEffect(() => {
    setState(getCollapseStates(routes));
    // eslint-disable-next-line
  }, []);
  // verifies if routeName is the one active (in browser input)
  const activeRoute = routeName => {
    return location.pathname.indexOf(routeName) > -1 ||
      filterState.filter === routeName
      ? "active"
      : "";
  };
  // makes the sidenav normal on hover (actually when mouse enters on it)
  const onMouseEnterSidenav = () => {
    if (!document.body.classList.contains("g-sidenav-pinned")) {
      document.body.classList.add("g-sidenav-show");
    }
  };
  // makes the sidenav mini on hover (actually when mouse leaves from it)
  const onMouseLeaveSidenav = () => {
    if (!document.body.classList.contains("g-sidenav-pinned")) {
      document.body.classList.remove("g-sidenav-show");
    }
  };
  // this creates the intial state of this component based on the collapse routes
  // that it gets through routes
  const getCollapseStates = routes => {
    let initialState = {};
    routes.map((prop, key) => {
      if (prop.collapse) {
        initialState = {
          [prop.state]: getCollapseInitialState(prop.views),
          ...getCollapseStates(prop.views),
          ...initialState,
        };
      }
      return null;
    });
    return initialState;
  };
  // this verifies if any of the collapses should be default opened on a rerender of this component
  // for example, on the refresh of the page,
  // while on the src/views/forms/RegularForms.js - route /admin/regular-forms
  const getCollapseInitialState = routes => {
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse && getCollapseInitialState(routes[i].views)) {
        return true;
      } else if (location.pathname.indexOf(routes[i].path) !== -1) {
        return true;
      }
    }
    return false;
  };
  // this is used on mobile devices, when a user navigates
  // the sidebar will autoclose
  const closeSidenav = () => {
    if (window.innerWidth < 1200) {
      toggleSidenav();
    }
  };
  // Change the filter accordingly
  const changeFilter = (location, prop) => {
    if (prop === "franchise") {
      dispatch(
        setFilter({
          franchise: location,
          address: null,
        })
      );
    } else {
      dispatch(
        setFilter({
          franchise: filterState.filter.franchise,
          address: location,
        })
      );
    }
  };
  // NotificationAlert function to create alert
  const notify = (type, title, message, icon) => {
    let options = {
      place: "tc",
      message: (
        <div className="alert-text">
          <span className="alert-title" data-notify="title">
            {" "}
            {title}
          </span>
          <span data-notify="message">{message}</span>
        </div>
      ),
      type: type,
      icon,
      autoDismiss: 7,
    };
    notificationAlertRef.current.notificationAlert(options);
  };

  const franchiseValid = async () => {
    try {
      const franchiseDoc = await firebase
        .firestore()
        .collection("franchises")
        .doc(franchiseSelect)
        .get();
      if (!franchiseDoc.exists) {
        dispatch(
          setFranchises({
            name: franchiseSelect,
            state: stateState,
            address: `${streetNumberState} ${streetNameState}`,
          })
        );
        return true;
      }
      const locationDoc = await firebase
        .firestore()
        .collection("franchises")
        .doc(franchiseSelect)
        .collection("locations")
        .doc(`${streetNumberState} ${streetNameState}`)
        .get();
      if (!locationDoc.exists) {
        dispatch(
          setFranchises({
            name: franchiseSelect,
            state: stateState,
            address: `${streetNumberState} ${streetNameState}`,
          })
        );
        return true;
      }
      if (locationDoc.data().owner === "") {
        dispatch(
          setFranchises({
            name: franchiseSelect,
            state: stateState,
            address: `${streetNumberState} ${streetNameState}`,
          })
        );
        return true;
      }
      return false;
    } catch (error) {
      console.error(error);
      notify("danger", "Uh Oh!", error.message, "fas fa-exclamation-triangle");
      return false;
    }
  };

  const isLimitReached = () => {
    let managers = 0;
    Object.keys(checklistsState.franchises).forEach(franchise => {
      if (managers > 0) return;
      checklistsState.franchises[franchise].locations.forEach(location => {
        managers += location.managers.length;
      });
    });
    return (
      userState.user.role === "owner" &&
      userState.user.plan === "free" &&
      managers > 0
    );
  };

  const handleDeleteLocation = (prop) => {
    dispatch(deleteLocation(prop.franchise, prop.name))
  }

  React.useEffect(async () => {
    if (isMounted.current) {
      await dispatch(getPerformanceData());
      dispatch(createDataStructure());
    } else {
      isMounted.current = true;
      return;
    }
  }, [filterState.filter.franchise, filterState.filter.address]);

  // this function creates the filters and collapses that appear in the sidebar (left menu)
  const createFilters = routes => {
    return routes.map((prop, key) => {
      if (prop.redirect) {
        return null;
      }
      if (prop.button) {
        return (
          <div
            onClick={() => setModalFranchise(true)}
            style={{
              padding: "0.675rem 1.5rem",
              color: "rgba(0, 0, 0, 0.6)",
              cursor: "pointer",
            }}
            className="d-flex align-items-center"
            key={key}
          >
            <i className={prop.icon} />
            <span className="ml-3" style={{ fontSize: "0.875rem" }}>
              {prop.name}
            </span>
          </div>
        );
      }
      if (prop.collapse) {
        var st = {};
        st[prop["state"]] = !state[prop.state];
        return (
          <NavItem key={key} style={{ cursor: "pointer" }}>
            <NavLink
              data-toggle="collapse"
              aria-expanded={state[prop.state]}
              className={classnames({
                active:
                  getCollapseInitialState(prop.views) ||
                  filterState.filter.franchise === prop.name,
              })}
              onClick={e => {
                e.preventDefault();
                setState(st);
                changeFilter(prop.name, "franchise");
              }}
              to={`#${prop.name}`}
            >
              {prop.icon ? (
                <>
                  <i className={prop.icon} />
                  <span className="nav-link-text">{prop.name}</span>
                </>
              ) : prop.miniName ? (
                <>
                  <span className="sidenav-mini-icon"> {prop.miniName} </span>
                  <span className="sidenav-normal"> {prop.name} </span>
                </>
              ) : null}
            </NavLink>
            <Collapse isOpen={state[prop.state]} style={{ cursor: "pointer" }}>
              <Nav className="nav-sm flex-column" style={{ cursor: "pointer" }}>
                {createFilters(prop.views)}
              </Nav>
            </Collapse>
          </NavItem>
        );
      }
      if (prop.name === "All Locations") {
        return (
          <NavItem className={activeRoute(prop.layout + prop.path)} key={key}>
            <NavLink
              to={prop.layout + prop.path}
              className={classnames({
                active: !filterState.filter.franchise,
              })}
              onClick={e => {
                e.preventDefault();
                closeSidenav();
                setState({});
                dispatch(setFilter({ franchise: null, address: null }));
              }}
              tag={NavLinkRRD}
            >
              {prop.icon !== undefined ? (
                <>
                  <i className={prop.icon} />
                  <span className="nav-link-text">{prop.name}</span>
                </>
              ) : prop.miniName !== undefined ? (
                <>
                  <span className="sidenav-mini-icon"> {prop.miniName} </span>
                  <span className="sidenav-normal"> {prop.name} </span>
                </>
              ) : (
                prop.name
              )}
            </NavLink>
          </NavItem>
        );
      }
      return (
        <NavItem className={activeRoute(prop.layout + prop.path)} key={key}>
          <NavLink
            to={prop.layout + prop.path}
            className={classnames({
              active: filterState.filter.address === prop.name,
            })}
            onClick={e => {
              e.preventDefault();
              e.stopPropagation()
              closeSidenav();
              changeFilter(prop.name, "address");
            }}
            tag={NavLinkRRD}
          >
            {prop.icon !== undefined ? (
              <div>
                {userState.user.role === "dtec" && (
                  <i className="far fa-trash-alt text-danger mt-3" onClick={() => setAlert(
                    <ReactBSAlert
                      warning
                      showCancel
                      style={{ display: "block", marginTop: "-100px" }}
                      title={`Delete ${prop.name}`}
                      onConfirm={() => {
                        setAlert(null);
                        handleDeleteLocation(prop);
                      }}
                      onCancel={() => setAlert(null)}
                      confirmBtnBsStyle="primary"
                      confirmBtnText="Delete"
                      cancelBtnBsStyle="secondary"
                      cancelBtnText="Cancel"
                      btnSize=""
                    >
                      {`You are about to delete ${prop.franchise} at ${prop.name}. This operation can not be undone and all information associated with it will be deleted as well.`}
                    </ReactBSAlert>
                  )}/>
                )}
                <i className={prop.icon} />
                <span className="nav-link-text">{prop.name}</span>
              </div>
            ) : prop.miniName !== undefined ? (
              <div>
                {userState.user.role === "dtec" && (
                  <i className="far fa-trash-alt text-danger mt-3"  onClick={() => setAlert(
                    <ReactBSAlert
                      warning
                      showCancel
                      style={{ display: "block", marginTop: "-100px" }}
                      title={`Delete ${prop.name}`}
                      onConfirm={() => {
                        setAlert(null);
                        handleDeleteLocation(prop);
                      }}
                      onCancel={() => setAlert(null)}
                      confirmBtnBsStyle="primary"
                      confirmBtnText="Delete"
                      cancelBtnBsStyle="secondary"
                      cancelBtnText="Cancel"
                      btnSize=""
                    >
                      {`You are about to delete ${prop.franchise} at ${prop.name}. This operation can not be undone and all information associated with it will be deleted as well.`}
                    </ReactBSAlert>
                  )}/>
                )}
                <span className="sidenav-normal"> {prop.name} </span>
              </div>
            ) : (
              prop.name
            )}
          </NavLink>
        </NavItem>
      );
    });
  };

  // this function creates the links and collapses that appear in the sidebar (left menu)
  const createLinks = routes => {
    return routes.map((prop, key) => {
      if (
        prop.redirect ||
        (userState.user.role === "em" && prop.name === "Billing")
      ) {
        return null;
      }
      if (prop.button) {
        return (
          <div
            onClick={() =>
              isLimitReached()
                ? setAlert(
                    <ReactBSAlert
                      warning
                      showCancel
                      style={{ display: "block", marginTop: "-100px" }}
                      title="Uh-Oh!"
                      onConfirm={() => {
                        setAlert(null);
                        history.push("/admin/billing");
                      }}
                      onCancel={() => setAlert(null)}
                      confirmBtnBsStyle="primary"
                      confirmBtnText="Yes, let's upgrade!"
                      cancelBtnBsStyle="secondary"
                      cancelBtnText="Cancel"
                      btnSize=""
                    >
                      You have already used your free mobile app account.
                      Upgrade to enjoy unlimited checklists, unlimited mobile
                      app accounts, user feedback, and much more!
                    </ReactBSAlert>
                  )
                : setUserModal(true)
            }
            style={{
              padding: "0.675rem 1.5rem",
              color: "rgba(0, 0, 0, 0.6)",
              cursor: "pointer",
            }}
            className="d-flex align-items-center"
            key={key}
          >
            <i className={prop.icon} />
            <span className="ml-3" style={{ fontSize: "0.875rem" }}>
              {prop.name}
            </span>
          </div>
        );
      }
      if (prop.collapse) {
        var st = {};
        st[prop["state"]] = !state[prop.state];
        return (
          <NavItem key={key}>
            <NavLink
              to={`#${prop.name}`}
              data-toggle="collapse"
              aria-expanded={state[prop.state]}
              className={classnames({
                active: getCollapseInitialState(prop.views),
              })}
              onClick={e => {
                e.preventDefault();
                setState(st);
              }}
            >
              {prop.icon ? (
                <>
                  <i className={prop.icon} />
                  <span className="nav-link-text">{prop.name}</span>
                </>
              ) : prop.miniName ? (
                <>
                  <span className="sidenav-mini-icon"> {prop.miniName} </span>
                  <span className="sidenav-normal"> {prop.name} </span>
                </>
              ) : null}
            </NavLink>
            <Collapse isOpen={state[prop.state]}>
              <Nav className="nav-sm flex-column">
                {createLinks(prop.views)}
              </Nav>
            </Collapse>
          </NavItem>
        );
      }
      return (
        <NavItem className={activeRoute(prop.layout + prop.path)} key={key}>
          <NavLink
            to={prop.layout + prop.path}
            activeClassName=""
            onClick={closeSidenav}
            tag={NavLinkRRD}
          >
            {prop.icon !== undefined ? (
              <>
                <i className={prop.icon} />
                <span className="nav-link-text">{prop.name}</span>
                {(prop.name === "Checklists Calendar" ||
                  prop.path.split("?")[0] === "/user") &&
                  userState.user.role === "owner" &&
                  userState.user.plan === "free" && (
                    <span>
                      <Badge color="primary" pill>
                        Pro
                      </Badge>
                    </span>
                  )}
              </>
            ) : prop.miniName !== undefined ? (
              <>
                <span className="sidenav-mini-icon"> {prop.miniName} </span>
                <span className="sidenav-normal"> {prop.name} </span>
              </>
            ) : (
              prop.name
            )}
          </NavLink>
        </NavItem>
      );
    });
  };

  const handleCreateUser = async e => {
    e.preventDefault();
    try {
      // Validate
      if (accountType === "em") {
        if (validEmail === "valid") {
          await firebase
            .firestore()
            .collection("usersWhitelist")
            .doc(email)
            .set({
              accountType,
              name,
            });
          setUserModal(false);
          clearState();
          return notify(
            "success",
            "Success!",
            `User ${email} was whitelisted successfully`,
            "fas fa-check"
          );
        }
      } else if (accountType === "owner") {
        if (
          validEmail === "valid" &&
          validFranchiseSelect === "valid" &&
          validStateState === "valid" &&
          validLocationSelect === "valid" &&
          validName === "valid"
        ) {
          await firebase
            .firestore()
            .collection("usersWhitelist")
            .doc(email)
            .set({
              accountType,
              code: code || "",
              franchise: franchiseSelect,
              location: locationSelect,
              state: stateState,
              name,
            });
          setUserModal(false);
          clearState();
          return notify(
            "success",
            "Success!",
            `User ${email} was whitelisted successfully`,
            "fas fa-check"
          );
        }
      } else if (
        validEmail === "valid" &&
        validFranchiseSelect === "valid" &&
        validLocationSelect === "valid"
      ) {
        await firebase.firestore().collection("usersWhitelist").doc(email).set({
          franchise: franchiseSelect,
          location: locationSelect,
          accountType,
          name,
        });
        setUserModal(false);
        clearState();
        return notify(
          "success",
          "Success!",
          `User ${email} was whitelisted successfully`,
          "fas fa-check"
        );
      }
      let message = "";
      if (!validName || validName === "invalid") {
        message += "Please provide a valid name.";
      }
      if (!validEmail || validEmail === "invalid") {
        message += "Please provide a valid email.";
      }
      if (!validFranchiseSelect || validFranchiseSelect === "invalid") {
        message += "Please select a Franchise";
      }
      if (!validLocationSelect || validLocationSelect === "invalid") {
        message += "Please select a location.";
      }
      return notify(
        "danger",
        "Please make sure everything is filled out correctly:",
        message,
        "fas fa-exclamation-triangle"
      );
      //Notify if invalid
    } catch (error) {
      console.error(error);
      setUserModal(false);
      return notify(
        "danger",
        "Uh Oh!",
        error.message,
        "fas fa-exclamation-triangle"
      );
    }
  };

  const handleCreateFranchise = async e => {
    e.preventDefault();
    try {
      if (
        validStreetName === "valid" &&
        validStreetNumber === "valid" &&
        validFranchiseSelect === "valid"
      ) {
        const isValid = await franchiseValid();
        if (!isValid) {
          setLoadingActive(false);
          return notify(
            "danger",
            "Uh Oh!",
            "This franchise already exists and has been claimed by another user. Please verify the information.\nIf you are the owner of this location please contact us.",
            "fas fa-exclamation-triangle"
          );
        }

        await dispatch(
          createFranchise({
            name: franchiseSelect,
            state: stateState,
            address: `${streetNumberState} ${streetNameState}`,
          })
        );

        setLoadingActive(false);
        setModalFranchise(false);
        if (checklistsState.status === "OK") {
          notify(
            "success",
            "Success!",
            "The Location was created successfully",
            "fas fa-check"
          );
        } else {
          notify(
            "danger",
            "Uh-Oh!",
            "Something went wrong. Please try again later",
            "fas fa-check"
          );
        }
        clearState();
      }
      if (!validStreetName || validStreetName === "invalid") {
        setValidStreetName("invalid");
      }
      if (!validStreetNumber || validStreetNumber === "invalid") {
        setValidStreetNumber("invalid");
      }
      if (!validStateState || validStateState === "invalid") {
        setValidStateState("invalid");
      }
      if (!validFranchiseSelect || validFranchiseSelect === "invalid") {
        setValidFranchiseSelect("invalid");
      }
    } catch (error) {
      console.error(error);
      setModalFranchise(false);
      return notify(
        "danger",
        "Uh Oh!",
        error.message,
        "fas fa-exclamation-triangle"
      );
    }
  };

  const clearState = () => {
    setValidEmail(null);
    setValidFranchiseSelect(null);
    setValidLocationSelect(null);
    setValidCode(null);
    setValidName(null);
    setEmail(null);
    setFranchiseSelect(null);
    setLocationSelect(null);
    if (userState.user.role !== "owner") setAccountType(null);
    setAlternativeFranchise(false);
    setCode(null);
    setName(null);
    setChecklistName(null);
    setFranchiseSelect([]);
    setLocationSelect([]);
    setStartTime(null);
    setEndTime(null);
    setEnviroMasterChecklist(userState.user.role === "owner" ? false : null);
    setQRNeeded(false);
    setMondayCheckbox(null);
    setTuesdayCheckbox(null);
    setWednesdayCheckbox(null);
    setThursdayCheckbox(null);
    setFridayCheckbox(null);
    setSaturdayCheckbox(null);
    setSundayCheckbox(null);
    setChecklistToUpdate(null);
    setChecklistItems([]);
    setModalTitle(null);
    // CLEAR VALIDATIONS
    setValidChecklistName(null);
    setValidFranchiseSelect(null);
    setValidLocationSelect(null);
    setValidStartTime(null);
    setValidEndTime(null);
    setValidEnviroMasterChecklist(
      userState.user.role === "owner" ? "valid" : null
    );
    setValidMondayCheckbox(null);
    setValidTuesdayCheckbox(null);
    setValidWednesdayCheckbox(null);
    setValidThursdayCheckbox(null);
    setValidFridayCheckbox(null);
    setValidSaturdayCheckbox(null);
    setValidSundayCheckbox(null);
  };

  // Locations menu.
  React.useEffect(() => {
    const franchises = Object.keys(checklistsState.franchises);
    setLocations([
      {
        name: "Add Location",
        icon: "ni ni-building text-success",
        button: true,
      },
      {
        name: "All Locations",
        icon: "ni ni-world text-danger",
      },
      ...franchises.map(franchise => ({
        collapse: true,
        name: franchise,
        icon: "ni ni-building text-danger",
        state: `${franchise}Collapse`,
        views: checklistsState.franchises[franchise].locations.map(
          location => ({
            franchise: franchise,
            name: location.address,
            miniName: location.address.split(" ")[0],
            component: "",
          })
        ),
      })),
    ]);
  }, [checklistsState.franchises, checklistsState.locations]);

  // Users menu
  React.useEffect(() => {
    const users = Object.keys(checklistsState.users);
    setUsers(
      [
        {
          name: "Grant user access",
          icon: "ni ni-circle-08 text-success",
          button: true,
        },
      ].concat(
        users.map(user => ({
          path: `/user?user=${user}`,
          name: checklistsState.users[user].name,
          icon: "ni ni-circle-08 text-danger",
          component: User,
          layout: "/admin",
        }))
      )
    );
  }, [checklistsState.users]);

  const scrollBarInner = (
    <div className="scrollbar-inner">
      <div className="sidenav-header d-flex align-items-center"></div>
      <div className="navbar-inner">
        <Collapse navbar isOpen={true}>
          <Nav navbar>{createLinks(routes)}</Nav>
          <hr className="my-3" />
          <h6 className="navbar-heading p-0 text-muted">
            <span className="docs-normal">Locations</span>
            <span className="docs-mini">L</span>
          </h6>
          <Nav navbar>{createFilters(locations)}</Nav>
          <hr className="my-3" />
          <h6 className="navbar-heading p-0 text-muted">
            <span className="docs-normal">Users</span>
            <span className="docs-mini">U</span>
          </h6>
          <Nav navbar>{createLinks(users)}</Nav>
        </Collapse>
      </div>
    </div>
  );
  return (
    <>
      {alert}
      <div className="rna-wrapper">
        <NotificationAlert ref={notificationAlertRef} />
      </div>
      <Modal
        isOpen={userModal}
        toggle={() => {
          setUserModal(false);
          clearState();
        }}
        className="modal-dialog-centered modal-secondary"
        style={{ width: "90%", maxWidth: "1200px" }}
      >
        <div className="modal-body">
          <Row>
            <div className="col">
              <Card className="shadow px-6">
                <CardHeader className="bg-transparent border-0">
                  <h3 className="mb-0">Grant User Access</h3>
                  <h5>
                    You are about to create an access for a user. The
                    information you fill out in here is the one the user will
                    have to add to their sign-up form.
                  </h5>
                </CardHeader>
                <h4>Select the type of account you will grant access to.</h4>
                <div className="d-flex justify-content-around mt-3 pb-3">
                  {userState.user.role === "dtec" ? (
                    <div className="custom-control custom-radio custom-control-inline">
                      <input
                        className="custom-control-input"
                        id="enviro-master"
                        name="accountType"
                        type="radio"
                        onChange={() => setAccountType("em")}
                      />
                      <label
                        className="custom-control-label"
                        htmlFor="enviro-master"
                      >
                        Enviro-Master Manager
                      </label>
                    </div>
                  ) : null}
                  {["dtec", "em"].includes(userState.user.role) ? (
                    <>
                      <div className="custom-control custom-radio custom-control-inline">
                        <input
                          className="custom-control-input"
                          id="owner"
                          name="accountType"
                          type="radio"
                          onChange={() => setAccountType("owner")}
                        />
                        <label className="custom-control-label" htmlFor="owner">
                          Franchise Owner
                        </label>
                      </div>
                      <div className="custom-control custom-radio custom-control-inline">
                        <input
                          className="custom-control-input"
                          id="manager"
                          name="accountType"
                          type="radio"
                          onChange={() => setAccountType("manager")}
                        />
                        <label
                          className="custom-control-label"
                          htmlFor="manager"
                        >
                          Location Manager
                        </label>
                      </div>
                      <div className="custom-control custom-radio custom-control-inline">
                        <input
                          className="custom-control-input"
                          id="technician"
                          name="accountType"
                          type="radio"
                          onChange={() => setAccountType("technician")}
                        />
                        <label
                          className="custom-control-label"
                          htmlFor="technician"
                        >
                          Technician
                        </label>
                      </div>
                    </>
                  ) : null}
                </div>
                {!accountType ? null : accountType === "em" ? (
                  <Form
                    className="edit-event--form pt-3"
                    id="form"
                    onSubmit={e => handleCreateUser(e)}
                  >
                    <FormGroup
                      className={classnames({
                        focused: focusedName,
                      })}
                    >
                      <InputGroup className="input-group-merge mb-3">
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText
                            style={
                              validName === "valid"
                                ? { borderColor: "#2dce89" }
                                : validName === "invalid"
                                ? { borderColor: "red" }
                                : {}
                            }
                          >
                            <i className="ni ni-hat-3" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          placeholder="Name"
                          type="text"
                          valid={validName === "valid"}
                          invalid={validName === "invalid"}
                          onFocus={() => setFocusedName(true)}
                          onBlur={() => setFocusedName(false)}
                          onChange={e => {
                            setName(e.target.value);
                            if (e.target.value !== "") {
                              setValidName("valid");
                            } else {
                              setValidName("invalid");
                            }
                          }}
                        />
                      </InputGroup>
                    </FormGroup>
                    <FormGroup
                      className={classnames({
                        focused: focusedEmail,
                      })}
                    >
                      <InputGroup className="input-group-merge mb-3">
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText
                            style={
                              validEmail === "valid"
                                ? { borderColor: "#2dce89" }
                                : validEmail === "invalid"
                                ? { borderColor: "red" }
                                : {}
                            }
                          >
                            <i className="ni ni-email-83" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          placeholder="Email"
                          type="email"
                          valid={validEmail === "valid"}
                          invalid={validEmail === "invalid"}
                          onFocus={() => setFocusedEmail(true)}
                          onBlur={() => setFocusedEmail(false)}
                          onChange={e => {
                            setEmail(e.target.value);
                            if (
                              /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
                                e.target.value
                              )
                            ) {
                              setValidEmail("valid");
                            } else {
                              setValidEmail("invalid");
                            }
                          }}
                        />
                      </InputGroup>
                    </FormGroup>
                  </Form>
                ) : (
                  <Form
                    className="edit-event--form pt-3"
                    id="form"
                    onSubmit={e => handleCreateUser(e)}
                  >
                    <FormGroup>
                      <Input
                        id="3"
                        type="select"
                        default="1"
                        valid={validFranchiseSelect === "valid"}
                        invalid={validFranchiseSelect === "invalid"}
                        onFocus={() => setFocusedFranchiseSelect(true)}
                        onBlur={() => setFocusedFranchiseSelect(false)}
                        onChange={e => {
                          setFranchiseSelect(e.target.value);
                          if (e.target.value === "") {
                            setValidFranchiseSelect("invalid");
                          } else {
                            setValidFranchiseSelect("valid");
                          }
                        }}
                      >
                        <option className="d-none" value="1">
                          Select the franchise the location belongs to.
                        </option>
                        {Object.keys(checklistsState.franchises).map(
                          franchise => (
                            <option key={franchise}>{franchise}</option>
                          )
                        )}
                      </Input>
                    </FormGroup>
                    {accountType === "owner" ? (
                      <>
                        <Row className="my-4">
                          <Col xs="12">
                            <div className="custom-control custom-control-alternative custom-checkbox">
                              <input
                                className="custom-control-input"
                                id="customCheckRegister2"
                                type="checkbox"
                                onChange={e => {
                                  setAlternativeFranchise(e.target.checked);
                                }}
                              />
                              <label
                                className="custom-control-label"
                                htmlFor="customCheckRegister2"
                              >
                                <span className="text-muted">
                                  The Restaurant's name is not on the list{" "}
                                </span>
                              </label>
                            </div>
                          </Col>
                        </Row>
                        {alternativeFranchise ? (
                          <FormGroup
                            className={classnames({
                              focused: focusedFranchiseSelect,
                            })}
                          >
                            <InputGroup className="input-group-merge mb-3">
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText
                                  style={
                                    validFranchiseSelect === "valid"
                                      ? { borderColor: "#2dce89" }
                                      : validFranchiseSelect === "invalid"
                                      ? { borderColor: "red" }
                                      : {}
                                  }
                                >
                                  <i className="ni ni-building" />
                                </InputGroupText>
                              </InputGroupAddon>
                              <Input
                                id="validationCustom01"
                                placeholder="Provide the Franchise/Restaurant name"
                                type="text"
                                valid={validFranchiseSelect === "valid"}
                                invalid={validFranchiseSelect === "invalid"}
                                onFocus={() => setFocusedFranchiseSelect(true)}
                                onBlur={() => setFocusedFranchiseSelect(false)}
                                onChange={e => {
                                  setFranchiseSelect(e.target.value);
                                  if (e.target.value === "") {
                                    setValidFranchiseSelect("invalid");
                                  } else {
                                    setValidFranchiseSelect("valid");
                                  }
                                }}
                              />
                            </InputGroup>
                          </FormGroup>
                        ) : (
                          <></>
                        )}
                      </>
                    ) : null}
                    {franchiseSelect ? (
                      accountType === "owner" ? (
                        <>
                          <FormGroup
                            className={classnames({
                              focused: focusedState,
                            })}
                          >
                            <Input
                              id="exampleFormControlSelect1"
                              type="select"
                              default="1"
                              valid={validStateState === "valid"}
                              invalid={validStateState === "invalid"}
                              onFocus={() => setFocusedState(true)}
                              onBlur={() => setFocusedState(false)}
                              onChange={e => {
                                setStateState(e.target.value);
                                if (e.target.value === "") {
                                  setValidStateState("invalid");
                                } else {
                                  setValidStateState("valid");
                                }
                              }}
                            >
                              <option className="d-none" value="1">
                                State
                              </option>
                              {states.map(state => (
                                <option key={state}>{state}</option>
                              ))}
                            </Input>
                          </FormGroup>
                          <FormGroup
                            className={classnames({
                              focused: focusedLocationSelect,
                            })}
                          >
                            <InputGroup className="input-group-merge mb-3">
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText
                                  style={
                                    validLocationSelect === "valid"
                                      ? { borderColor: "#2dce89" }
                                      : validLocationSelect === "invalid"
                                      ? { borderColor: "red" }
                                      : {}
                                  }
                                >
                                  <i className="ni ni-building" />
                                </InputGroupText>
                              </InputGroupAddon>
                              <Input
                                id="validationCustom01"
                                placeholder="Provide the Franchise/Restaurant address"
                                type="text"
                                valid={validLocationSelect === "valid"}
                                invalid={validLocationSelect === "invalid"}
                                onFocus={() => setFocusedLocationSelect(true)}
                                onBlur={() => setFocusedLocationSelect(false)}
                                onChange={e => {
                                  setLocationSelect(e.target.value);
                                  if (e.target.value === "") {
                                    setValidLocationSelect("invalid");
                                  } else {
                                    setValidLocationSelect("valid");
                                  }
                                }}
                              />
                            </InputGroup>
                            <small>
                              * Please make sure the address is correct, you
                              won't be able to change it later.
                            </small>
                          </FormGroup>
                        </>
                      ) : (
                        <FormGroup>
                          <Input
                            id="3"
                            type="select"
                            default="1"
                            valid={validLocationSelect === "valid"}
                            invalid={validLocationSelect === "invalid"}
                            onFocus={() => setFocusedLocationSelect(true)}
                            onBlur={() => setFocusedLocationSelect(false)}
                            onChange={e => {
                              setLocationSelect(e.target.value);
                              if (e.target.value === "") {
                                setValidLocationSelect("invalid");
                              } else {
                                setValidLocationSelect("valid");
                              }
                            }}
                          >
                            <option className="d-none" value="1">
                              Select the Location that the user will be
                              attending.
                            </option>
                            {checklistsState.franchises[
                              franchiseSelect
                            ]?.locations.map(location => (
                              <option key={location.address}>
                                {location.address}
                              </option>
                            ))}
                          </Input>
                          <small>
                            * You will be able to modify this in the future.
                            Just go to the user's page and select the new
                            location they will be managing.
                          </small>
                        </FormGroup>
                      )
                    ) : null}
                    <FormGroup
                      className={classnames({
                        focused: focusedName,
                      })}
                    >
                      <InputGroup className="input-group-merge mb-3">
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText
                            style={
                              validName === "valid"
                                ? { borderColor: "#2dce89" }
                                : validName === "invalid"
                                ? { borderColor: "red" }
                                : {}
                            }
                          >
                            <i className="ni ni-hat-3" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          placeholder="Name"
                          type="text"
                          valid={validName === "valid"}
                          invalid={validName === "invalid"}
                          onFocus={() => setFocusedName(true)}
                          onBlur={() => setFocusedName(false)}
                          onChange={e => {
                            setName(e.target.value);
                            if (e.target.value !== "") {
                              setValidName("valid");
                            } else {
                              setValidName("invalid");
                            }
                          }}
                        />
                      </InputGroup>
                    </FormGroup>
                    <FormGroup
                      className={classnames({
                        focused: focusedEmail,
                      })}
                    >
                      <InputGroup className="input-group-merge mb-3">
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText
                            style={
                              validEmail === "valid"
                                ? { borderColor: "#2dce89" }
                                : validEmail === "invalid"
                                ? { borderColor: "red" }
                                : {}
                            }
                          >
                            <i className="ni ni-email-83" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          placeholder="Email"
                          type="email"
                          valid={validEmail === "valid"}
                          invalid={validEmail === "invalid"}
                          onFocus={() => setFocusedEmail(true)}
                          onBlur={() => setFocusedEmail(false)}
                          onChange={e => {
                            setEmail(e.target.value);
                            if (
                              /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
                                e.target.value
                              )
                            ) {
                              setValidEmail("valid");
                            } else {
                              setValidEmail("invalid");
                            }
                          }}
                        />
                      </InputGroup>
                    </FormGroup>
                    {accountType === "owner" ? (
                      <FormGroup
                        className={classnames({
                          focused: focusedCode,
                        })}
                      >
                        <InputGroup className="input-group-merge mb-3">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText
                              style={
                                validCode === "valid"
                                  ? { borderColor: "#2dce89" }
                                  : validCode === "invalid"
                                  ? { borderColor: "red" }
                                  : {}
                              }
                            >
                              <i className="fab fa-cc-stripe" />
                            </InputGroupText>
                          </InputGroupAddon>
                          <Input
                            id="validationCustom01"
                            placeholder="If the client has payed, please include the Stripe Payment Code."
                            type="text"
                            valid={validCode === "valid"}
                            invalid={validCode === "invalid"}
                            onFocus={() => setFocusedCode(true)}
                            onBlur={() => setFocusedCode(false)}
                            onChange={e => {
                              setCode(e.target.value);
                              if (e.target.value === "") {
                                setValidCode("invalid");
                              } else {
                                setValidCode("valid");
                              }
                            }}
                            value={code}
                          />
                        </InputGroup>
                      </FormGroup>
                    ) : null}
                  </Form>
                )}
              </Card>
            </div>
          </Row>
        </div>
        <div className="modal-footer">
          <Button color="primary" type="button" type="submit" form="form">
            Create User Access
          </Button>
          <Button
            color="secondary"
            onClick={() => {
              setUserModal(false);
              clearState();
            }}
          >
            Close
          </Button>
        </div>
      </Modal>

      <Modal
        isOpen={modalFranchise}
        toggle={() => {
          setModalFranchise(false);
          clearState();
        }}
        className="modal-dialog-centered modal-secondary"
        style={{ width: "90%", maxWidth: "1200px" }}
      >
        <div className="modal-body">
          <Row>
            <div className="col">
              <Card className="shadow px-6">
                <CardHeader className="bg-transparent border-0">
                  <h3 className="mb-0">
                    Create new Location
                    <span className="text-primary">
                      {checklistToCopy ? checklistToCopy.name : ""}
                    </span>
                  </h3>
                </CardHeader>
                <Form
                  className="edit-event--form pt-3"
                  id="form"
                  onSubmit={e => handleCreateFranchise(e)}
                >
                  <FormGroup>
                    <Input
                      id="3"
                      type="select"
                      default="1"
                      valid={validFranchiseSelect === "valid"}
                      invalid={validFranchiseSelect === "invalid"}
                      onFocus={() => setFocusedFranchiseSelect(true)}
                      onBlur={() => setFocusedFranchiseSelect(false)}
                      onChange={e => {
                        setFranchiseSelect(e.target.value);
                        if (e.target.value === "") {
                          setValidFranchiseSelect("invalid");
                        } else {
                          setValidFranchiseSelect("valid");
                        }
                      }}
                    >
                      <option className="d-none" value="1">
                        Select the franchise the location belongs to.
                      </option>
                      {Object.keys(checklistsState.franchises).map(
                        franchise => (
                          <option key={franchise}>{franchise}</option>
                        )
                      )}
                    </Input>
                  </FormGroup>
                  <Row className="my-4">
                    <Col xs="12">
                      <div className="custom-control custom-control-alternative custom-checkbox">
                        <input
                          className="custom-control-input"
                          id="customCheckRegister2"
                          type="checkbox"
                          onChange={e => {
                            setAlternativeFranchise(e.target.checked);
                          }}
                        />
                        <label
                          className="custom-control-label"
                          htmlFor="customCheckRegister2"
                        >
                          <span className="text-muted">
                            My Restaurant's name is not on the list{" "}
                          </span>
                        </label>
                      </div>
                    </Col>
                  </Row>
                  {alternativeFranchise ? (
                    <FormGroup
                      className={classnames({
                        focused: focusedFranchise,
                      })}
                    >
                      <InputGroup className="input-group-merge mb-3">
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText
                            style={
                              validFranchiseSelect === "valid"
                                ? { borderColor: "#2dce89" }
                                : validFranchiseSelect === "invalid"
                                ? { borderColor: "red" }
                                : {}
                            }
                          >
                            <i className="ni ni-building" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          id="validationCustom01"
                          placeholder="Provide your Franchise/Restaurant name"
                          type="text"
                          valid={validFranchiseSelect === "valid"}
                          invalid={validFranchiseSelect === "invalid"}
                          onFocus={() => setFocusedFranchise(true)}
                          onBlur={() => setFocusedFranchise(false)}
                          onChange={e => {
                            setFranchiseSelect(e.target.value);
                            if (e.target.value === "") {
                              setValidFranchiseSelect("invalid");
                            } else {
                              setValidFranchiseSelect("valid");
                            }
                          }}
                        />
                      </InputGroup>
                    </FormGroup>
                  ) : null}
                  <hr />
                  <h6 className="mb-3">Address Information</h6>
                  <FormGroup
                    className={classnames({
                      focused: focusedState,
                    })}
                  >
                    <Input
                      id="exampleFormControlSelect1"
                      type="select"
                      default="1"
                      valid={validStateState === "valid"}
                      invalid={validStateState === "invalid"}
                      onFocus={() => setFocusedState(true)}
                      onBlur={() => setFocusedState(false)}
                      onChange={e => {
                        setStateState(e.target.value);
                        if (e.target.value === "") {
                          setValidStateState("invalid");
                        } else {
                          setValidStateState("valid");
                        }
                      }}
                    >
                      <option className="d-none" value="1">
                        State
                      </option>
                      {states.map(state => (
                        <option key={state}>{state}</option>
                      ))}
                    </Input>
                  </FormGroup>
                  <Row className="my-4">
                    <Col xs="5">
                      <FormGroup
                        className={classnames({
                          focused: focusedStreetNumber,
                        })}
                      >
                        <InputGroup className="input-group-merge mb-3">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText
                              style={
                                validStreetNumber === "valid"
                                  ? { borderColor: "#2dce89" }
                                  : validStreetNumber === "invalid"
                                  ? { borderColor: "red" }
                                  : {}
                              }
                            >
                              <i className="ni ni-shop" />
                            </InputGroupText>
                          </InputGroupAddon>
                          <Input
                            id="validationCustom01"
                            placeholder="Street Number"
                            type="text"
                            valid={validStreetNumber === "valid"}
                            invalid={validStreetNumber === "invalid"}
                            onFocus={() => setFocusedStreetNumber(true)}
                            onBlur={() => setFocusedStreetNumber(false)}
                            onChange={e => {
                              setStreetNumberState(e.target.value);
                              if (e.target.value === "") {
                                setValidStreetNumber("invalid");
                              } else {
                                setValidStreetNumber("valid");
                              }
                            }}
                          />
                        </InputGroup>
                      </FormGroup>
                    </Col>
                    <Col xs="7">
                      <FormGroup
                        className={classnames({
                          focused: focusedStreetName,
                        })}
                      >
                        <InputGroup className="input-group-merge mb-3">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText
                              style={
                                validStreetName === "valid"
                                  ? { borderColor: "#2dce89" }
                                  : validStreetName === "invalid"
                                  ? { borderColor: "red" }
                                  : {}
                              }
                            >
                              <i className="ni ni-square-pin" />
                            </InputGroupText>
                          </InputGroupAddon>
                          <Input
                            id="validationCustom01"
                            placeholder="Street Name"
                            type="text"
                            valid={validStreetName === "valid"}
                            invalid={validStreetName === "invalid"}
                            onFocus={() => setFocusedStreetName(true)}
                            onBlur={() => setFocusedStreetName(false)}
                            onChange={e => {
                              setStreetNameState(e.target.value);
                              if (e.target.value === "") {
                                setValidStreetName("invalid");
                              } else {
                                setValidStreetName("valid");
                              }
                            }}
                          />
                        </InputGroup>
                      </FormGroup>
                    </Col>
                  </Row>
                </Form>
              </Card>
            </div>
          </Row>
        </div>
        <div className="modal-footer">
          <Button color="primary" type="button" type="submit" form="form">
            Create Location
          </Button>
          <Button
            color="secondary"
            onClick={() => {
              setModalFranchise(false);
              clearState();
            }}
          >
            Close
          </Button>
        </div>
      </Modal>

      <Navbar
        className={
          "sidenav navbar-vertical navbar-expand-xs navbar-light bg-white " +
          (rtlActive ? "" : "fixed-left")
        }
        onMouseEnter={onMouseEnterSidenav}
        onMouseLeave={onMouseLeaveSidenav}
      >
        {navigator.platform.indexOf("Win") > -1 ? (
          <PerfectScrollbar>{scrollBarInner}</PerfectScrollbar>
        ) : (
          scrollBarInner
        )}
      </Navbar>
    </>
  );
}

Sidebar.defaultProps = {
  routes: [{}],
  toggleSidenav: () => {},
  sidenavOpen: false,
  rtlActive: false,
};

Sidebar.propTypes = {
  // function used to make sidenav mini or normal
  toggleSidenav: PropTypes.func,
  // prop to know if the sidenav is mini or normal
  sidenavOpen: PropTypes.bool,
  // links that will be displayed inside the component
  routes: PropTypes.arrayOf(PropTypes.object),
  // logo
  logo: PropTypes.shape({
    // innerLink is for links that will direct the user within the app
    // it will be rendered as <Link to="...">...</Link> tag
    innerLink: PropTypes.string,
    // outterLink is for links that will direct the user outside the app
    // it will be rendered as simple <a href="...">...</a> tag
    outterLink: PropTypes.string,
    // the image src of the logo
    imgSrc: PropTypes.string.isRequired,
    // the alt for the img
    imgAlt: PropTypes.string.isRequired,
  }),
  // rtl active, this will make the sidebar to stay on the right side
  rtlActive: PropTypes.bool,
};

export default Sidebar;
